import { useOutletContext } from "react-router";

import CuteBanner from "../shopping/component/themes/cute/banner";
import ModernBanner from "../shopping/component/themes/modern/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";

import { Container } from "../common/styled";
import Viewer from "./portfolioView/viewer";

const PortfolioViewPage = () => {
  const { theme } = useOutletContext();

  const banners = {
    0: ModernBanner,
    1: ChicBanner,
    2: ModernBanner,
    3: CuteBanner,
    4: SimpleBanner,
  };

  const renderComponent = () => {
    const Banner = banners[theme];

    return (
      <>
        {Banner && <Banner />}
        <Viewer />
      </>
    );
  };

  return <Container className={`theme-${theme}`}>{renderComponent()}</Container>;
};

export default PortfolioViewPage;
